import Counter from "../ui/Counter/Counter";
import { Heading } from "../ui/Heading/Heading";
import "./Impression.css";

const impactMetrics = [
  {
    metric: 2,
    suffix: "M+",
    label: "Visitors Hosted",
  },
  {
    metric: 100,
    suffix: "+",
    label: "Interactions Carried",
  },
  {
    metric: 100,
    suffix: "%",
    label: "Satisfaction Rate",
  },
];

export const Impression = () => {
  return (
    <div className=" h-[50vh] w-screen flex flex-col justify-center items-center gap-20 ">
      <div className=" w-full flex flex-col justify-center items-center gap-10">
        <Heading placeholder="Our Impression" />
        <div className=" w-3/5 flex flex-col lg:flex-row gap-4 lg:gap-0 justify-between items-center">
          {impactMetrics.map((impactMetric, index) => {
            return (
              <div
                key={index}
                className="flex flex-col font-gilroy-light text-[24px] justify-center items-center leading-12"
              >
                <div className="text-[72px] flex justify-center items-center">
                  <Counter
                    number={impactMetric.metric}
                    duration={2}
                    className="hollow-text"
                  />
                  <span className=" hollow-text ">{impactMetric.suffix}</span>
                </div>
                <label className="font-gilroy-medium">
                  <span className="font-nyght-serif-medium-italic">
                    {impactMetric.label}
                  </span>{" "}
                </label>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
